'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageSizeSettings = require('./PageSizeSettings');

var _PageSizeSettings2 = _interopRequireDefault(_PageSizeSettings);

var _ColumnChooser = require('./ColumnChooser');

var _ColumnChooser2 = _interopRequireDefault(_ColumnChooser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  pageSizeSettings: { order: 1, component: _PageSizeSettings2.default },
  columnChooser: { order: 2, component: _ColumnChooser2.default }
};

exports.default = components;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/settingsComponentObjects/index.js
// module id = 401
// module chunks = 0